import { render, staticRenderFns } from "./OptionSelect.vue?vue&type=template&id=5c3d4cda&scoped=true&"
import script from "./OptionSelect.vue?vue&type=script&lang=js&"
export * from "./OptionSelect.vue?vue&type=script&lang=js&"
import style0 from "./OptionSelect.vue?vue&type=style&index=0&id=5c3d4cda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3d4cda",
  null
  
)

component.options.__file = "OptionSelect.vue"
export default component.exports